/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 */

export const LIST_AUTH_OPTIONS = 'LIST_AUTH_OPTIONS';
export const AUTHOMATIC_REDIRECT = 'AUTHOMATIC_LOGIN_START';
export const OIDC_REDIRECT = 'OIDC_LOGIN_START';
export const LOGIN = 'LOGIN';
export const LOGOUT_OIDC = 'LOGOUT_OIDC';
